import { Directive } from "@angular/core";

/**
 * A wrapper for form action buttons (save, update, delete) in a mat-card.
 * Provides consistent spacing and alignment for action buttons.
 *
 * @example
 * <mat-card>
 *   <mgd-card-content>...</mgd-card-content>
 *   <mgd-card-form-actions>
 *     <button mat-raised-button>Save</button>
 *     <button mat-button>Cancel</button>
 *   </mgd-card-form-actions>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-form-actions",
    host: {
        class: "mgd-card-form-actions"
    }
})
export class CardFormActionsDirective {}
